import { Box } from "@mui/material";
import { ScoreRating } from "~/operations";
import WorkflowRiskDots from "../../WorkflowRiskDots";

export function WorkflowScopeTableRiskCell({ value }: { value: ScoreRating }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <WorkflowRiskDots riskRating={value} />
    </Box>
  );
}
